import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import type { PackageFormState } from '@openx/types/package.ts';
import { useTranslation } from 'react-i18next';

type MerchandisingDetailsProps = {
  pckg: PackageFormState;
};

export function MerchandisingDetails({ pckg }: MerchandisingDetailsProps) {
  const { t } = useTranslation();

  return (
    <FormSection divider title={t('Merchandising Details')}>
      <FieldDetails title={t('Package Logo')} value={pckg.logo} />
      <FieldDetails title={t('Domains or App names')} value={pckg.domains} />
      <FieldDetails title={t('Sample URLs')} value={pckg.urls} />
    </FormSection>
  );
}
